import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-mfa-help-dialog',
  templateUrl: './mfa-help-dialog.component.html',
  styleUrl: './mfa-help-dialog.component.scss',
})
export class MfaHelpDialogComponent {
  readonly dialogRef = inject(MatDialogRef<MfaHelpDialogComponent>);

  constructor() {}
}
